import React from "react";
import { Clock, MapPin, RefreshCw } from "lucide-react";
import LogoHiepHoi from "../assets/images/logo_hiephoi.jpg";
import Logofairplay from "../assets/images/fairplay.png";

const TournamentHeader = ({
  tournamentInfo = {},
  onRefresh,
  lastUpdated,
  isLoading,
}) => {
  return (
    <div className="bg-blue-700 text-white p-4 rounded-lg shadow-md">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <div className="bg-white rounded-full mr-4">
            {/* <div className="h-12 w-12 rounded-full bg-blue-200 flex items-center justify-center text-blue-800 font-bold">
              VGDA
            </div> */}
            <img
              src={LogoHiepHoi}
              alt="Logo"
              className="h-20 w-20 rounded-full"
            />
          </div>
          <div>
            <h1 className="text-2xl font-bold">{tournamentInfo.name}</h1>
            <div className="flex mt-1 text-sm">
              <div className="flex items-center mr-4">
                <Clock size={16} className="mr-1" />
                <span>{tournamentInfo.date}</span>
              </div>
              <div className="flex items-center">
                <MapPin size={16} className="mr-1" />
                <span>{tournamentInfo.location}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center">
          <div className="mr-2 text-right hidden md:block">
            <p className="text-sm">Tổ chức bởi</p>
            <p className="font-semibold">{tournamentInfo.organizerName}</p>
          </div>
          <div className="bg-white rounded-full">
            {/* <div className="h-10 w-10 rounded-full bg-red-200 flex items-center justify-center text-red-800 font-bold">
              FPS
            </div> */}
            <img
              src={Logofairplay}
              alt="Logo"
              className="h-20 w-20 rounded-full"
            />
          </div>
        </div>
      </div>
      <div className="flex justify-between items-center mt-4">
        <h2 className="text-xl font-bold">Lịch thi đấu & Kết quả</h2>
        <button
          onClick={onRefresh}
          disabled={isLoading}
          className="bg-blue-600 text-white px-3 py-2 rounded-md text-sm flex items-center transition hover:bg-blue-700 disabled:opacity-50"
        >
          <RefreshCw
            size={16}
            className={`mr-1 ${isLoading ? "animate-spin" : ""}`}
          />
          Cập nhật
        </button>
      </div>
      <p className="text-sm text-blue-200 mt-1">
        Cập nhật gần nhất: {lastUpdated}
      </p>
    </div>
  );
};

export default TournamentHeader;
